import React from "react";
import { useI18n } from "../../../lib/i18n";

/**
 * Reusable KPI card matching CARTAL aesthetic.
 * `tone` = "default" | "accent" | "soft"
 */
export default function KpiCard({ icon: Icon, labelAr, labelEn, value, sub, tone = "default", testid }) {
  const { lang } = useI18n();
  const isAccent = tone === "accent";
  const isSoft = tone === "soft";
  const base = "rounded-2xl p-4 border transition-colors";
  const style = isAccent
    ? { background: "linear-gradient(135deg,#0a0a0a,#1f1614)", borderColor: "transparent" }
    : isSoft
      ? { background: "#f7f4ea", borderColor: "rgba(201,165,92,0.15)" }
      : { background: "#ffffff", borderColor: "rgba(10,10,10,0.06)" };
  const textColor = isAccent ? "#f7eecd" : "#0a0a0a";
  const iconColor = isAccent ? "#e8c873" : "#8a6f2e";
  return (
    <div className={base} style={style} data-testid={testid}>
      <div className="flex items-center gap-2 mb-2">
        {Icon && <Icon className="w-4 h-4" style={{ color: iconColor }} />}
        <div className="text-[11px] font-semibold" style={{ color: isAccent ? "rgba(247,238,205,0.75)" : "#8a6f2e" }}>
          {lang === "ar" ? (labelAr || labelEn) : (labelEn || labelAr)}
        </div>
      </div>
      <div className="text-2xl font-bold font-display" style={{ color: textColor }}>
        {value == null || value === "" ? "—" : typeof value === "number" ? value.toLocaleString() : value}
      </div>
      {sub && (
        <div className="text-[11px] mt-1" style={{ color: isAccent ? "rgba(247,238,205,0.55)" : "#8a8a8a" }}>{sub}</div>
      )}
    </div>
  );
}
